import * as React from 'react';
import InlineRetailMediaAd, { AdSize } from 'webapp/components/retail-media/InlineRetailMediaBannerAd';

const BANNER_POSITIONS = {
  primary: {
    halfWidth: 15,
    fullWidth: 13,
  },
  secondary: {
    halfWidth: 16,
    fullWidth: 12,
  },
} as const;

export function renderRetailMediaBanner(
  currentProductIndex: number,
  ad?: NordicNest.Api.RetailMediaBanner,
  isSmallViewport?: boolean,
  hasAds?: boolean,
) {
  if (!ad) {
    return null;
  }

  const isPrimaryPosition =
    ad.format === 'halfWidth'
      ? isSmallViewport || !hasAds
        ? currentProductIndex === BANNER_POSITIONS.secondary.halfWidth
        : currentProductIndex === BANNER_POSITIONS.primary.halfWidth
      : isSmallViewport || !hasAds
      ? currentProductIndex === BANNER_POSITIONS.secondary.fullWidth
      : currentProductIndex === BANNER_POSITIONS.primary.fullWidth;

  if (!isPrimaryPosition) {
    return null;
  }

  return (
    <InlineRetailMediaAd
      key={currentProductIndex}
      banner={ad}
      size={ad.format === 'halfWidth' ? AdSize.Medium : AdSize.Large}
    />
  );
}
